var environmentUrls = /** @class */ (function () {
    function environmentUrls() {
    }
    environmentUrls.coreBaseUrl = "https://api2-test.dwyergroup.com/Core/V5";
    environmentUrls.identityBaseUrl = "https://api2-test.dwyergroup.com/Identity/V1";
    environmentUrls.franchiseGroupBaseUrl = "https://api.nblytest.com/franchisegroup-api-release/v1";
    environmentUrls.callCenterOrchestrationsBaseUrl = "https://api.nblytest.com/callcenterorchestrations-api-release/v1";
    environmentUrls.unifiedSyncPlatformBaseUrl = "localhost:3001";
    environmentUrls.serviceOrchestrationsApiBaseUrl = "https://api.nblytest.com/serviceorchestrations-api-release/v1";
    environmentUrls.syncGroupUrl = "https://api2-test-syncgroup.dwyergroup.com";
    return environmentUrls;
}());
export { environmentUrls };
